<div class="modal-overlay" (click)="fechar()"></div>

<div class="modal-panel">

  <!-- Sucesso -->
  <div class="sucesso-screen" *ngIf="sucesso">
    <div class="sucesso-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    </div>
    <h2 class="sucesso-title">Report enviado!</h2>
    <p class="sucesso-desc">Recebemos seu relato. Nossa equipe irá analisar em breve.</p>
    <button class="btn-primary" (click)="fechar()"type="button">Fechar</button>
  </div>

  <ng-container *ngIf="!sucesso">
    <div class="modal-header">
      <div class="modal-header-left">
        <div class="modal-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <div>
          <h2 class="modal-title">Reportar erro no contato</h2>
          <p class="modal-subtitle">Informe a inconsistência encontrada</p>
        </div>
      </div>
      <button class="btn-close" (click)="fechar()" type="button">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="contact-info">
        <div class="contact-info-row">
          <div class="info-group">
            <span class="info-label">Contato</span>
            <span class="info-value info-value--name">{{ contactName }}</span>
          </div>
          <div class="info-group">
            <span class="info-label">Cargo</span>
            <span class="info-value">{{ contactRole || 'Não informado' }}</span>
          </div>
        </div>
        <div class="contact-info-row">
          <div class="info-group">
            <span class="info-label">E-mail</span>
            <span class="info-value">{{ contactEmail || 'Não informado' }}</span>
          </div>
          <div class="info-group">
            <span class="info-label">Telefone</span>
            <span class="info-value">{{ contactPhone || 'Não informado' }}</span>
          </div>
        </div>
        <div class="contact-info-row">
          <div class="info-group">
            <span class="info-label">{{ rotuloEmpresa }}</span>
            <span class="info-value">{{ constructorName || 'Não informado' }}</span>
          </div>
          <div class="info-group" *ngIf="exibirObra">
            <span class="info-label">Obra</span>
            <span class="info-value">{{ workName || 'Não informado' }}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">
          Descreva o erro encontrado
          <span class="required">*</span>
        </label>
        <textarea
          class="form-textarea"
          [class.form-textarea--error]="submitted && !message.trim()"
          [(ngModel)]="message"
          placeholder="Ex: O telefone informado não existe mais, tentei contato e retornou como número inválido."
          rows="4"
          maxlength="2000"
        ></textarea>
        <div class="textarea-footer">
          <span class="error-msg" *ngIf="submitted && !message.trim()">A mensagem é obrigatória</span>
          <span class="char-count">{{ message.length }}/2000</span>
        </div>
      </div>

    </div>

    <p class="erro-envio" *ngIf="erroEnvio">{{ erroEnvio }}</p>

    <div class="modal-footer">
      <button class="btn-secondary" (click)="fechar()" type="button">Cancelar</button>
      <button class="btn-primary" (click)="enviar()" type="button">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
        Enviar report
      </button>
    </div>
  </ng-container>

</div>